export enum AccessLevel {
    Anonymous,
    // leaderboard viewer
    Viewer,
    Readonly,
    // FortiPOC environment reporting to the leaderboard
    Environment,
    Player,
    Admin,
    Unknown,
    Any,
    None
}
